const updates = [
  { date: '08-01', title: '《星河纪元：重启》高清版上线', tag: '新片入库' },
  { date: '07-30', title: '暑期档特别专题：国产科幻电影大盘点', tag: '专题' },
  { date: '07-28', title: '播放器升级完成，4K片源加载速度提升40%', tag: '系统' },
  { date: '07-25', title: '《暗夜追踪者》口碑发酵，新增导演访谈特辑', tag: '内容' },
  { date: '07-22', title: '经典修复单元上线：20部影史佳作4K重制', tag: '专题' },
  { date: '07-19', title: '移动端观影体验全面优化，适配最新系统', tag: '系统' },
  { date: '07-16', title: '影迷社区功能上线，话题广场支持实时互动', tag: '功能' },
  { date: '07-13', title: '《长安十二夜》独家幕后花絮首发', tag: '内容' },
  { date: '07-10', title: '纪录片频道扩容：新增自然与人文系列50部', tag: '新片入库' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">最新动态</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">萝卜影视的每一次更新，都为你带来更好的观影体验</p>
        <div className="relative pl-8 border-l-2 border-background-200/60 ml-3 space-y-8">
          {updates.map((item, i) => (
            <div key={i} className="relative">
              <span className="absolute -left-[calc(2rem+5px)] top-0 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100"></span>
              <div className="flex items-center gap-3 mb-1">
                <span className="text-xs font-medium text-primary-400 whitespace-nowrap">{item.date}</span>
                <span className="text-xs px-2 py-0.5 rounded-full bg-background-200/50 text-foreground-500 whitespace-nowrap">{item.tag}</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-200">{item.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}